const configs = {
  dev: {
    ApiBaseUrl: 'https://api.hounds.fewcents.co/v1',
    defaultLogoUrl:
      'https://pngimg.com/uploads/apple_logo/apple_logo_PNG19670.png',
    headerUrl: 'https://dev.fewcents.co/static/js/paywall.js',
  },
  demo: {
    ApiBaseUrl: 'https://api.demo.fewcents.co/v1',
    defaultLogoUrl:
      'https://pngimg.com/uploads/apple_logo/apple_logo_PNG19670.png',
    headerUrl: 'https://demo.fewcents.co/static/js/paywall.js',
  },
  prod: {
    ApiBaseUrl: 'https://api.fewcents.co/v1',
    defaultLogoUrl:
      'https://pngimg.com/uploads/apple_logo/apple_logo_PNG19670.png',
    headerUrl: 'https://prod.fewcents.co/static/js/paywall.js',
  },
};

const environment = 'dev';
const config = configs[environment];

export default config;
